import React from 'react';
import { inject, observer } from 'mobx-react';
import styles from './index.module.scss';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { BASE_IMG_URL } from '@images/imageUrls';
import classNames from 'classnames';
import { formatDateTime } from '@utils/timeUtils'; // 相对路径
import { formatNumberToWan } from '@utils/formatNumber';
import InfiniteScrollList from '@components/InfiniteScrollList';
import { highlightname } from '@utils/high-light-name';
import updateImageListSrc from '@utils/update-image-list-src'

interface PCActivityListProps extends RouteComponentProps {
    app?: AppStore;
    site?: SiteStore;
    user?: UserAction;
    data: any;
    loading?: boolean;
    hasMore?: boolean;
    onLoadMore?: () => void;
    emptyText?: string; // 为空时提示文字
    emptyIcon?: string; // 为空时icon
    emptyBoxStyle?: any; // 为空状态时的自定义样式
    isLeftSize?: any
    searchKeyword?: any
}

@inject('app', 'site',)
@observer
class PCActivityList extends React.Component<PCActivityListProps> {
    componentDidMount() {
        // 可以在这里添加初始化逻辑
    }

    // 渲染单个列表项
    renderActivityItem = (item: any, index: number) => {
        const { isLeftSize, searchKeyword } = this.props;
        // 根据状态获取按钮文本
        const getButtonText = (item: any) => {
            // status: 0 未开始 1 进行中 2 已结束
            if (item.status === 2) {
                // 已结束
                return '查看活动';
            } else if (item.status === 1 || item.status === 0) {
                // 进行中或未开始
                return item.thread?.hasForm ? '立即报名' : '立即参与';
            }
            return '';
        };

        // 获取状态文本
        const getStatusText = (status: number) => {
            const statusMap: { [key: number]: string } = {
                0: '未开始',
                1: '进行中',
                2: '已结束'
            };
            return statusMap[status] || '';
        };

        // 判断是否进行中（用于样式）
        const isInProgress = (status: number) => status === 1;
        const buttonText = getButtonText(item);
        const statusText = getStatusText(item.status);
        const inProgress = isInProgress(item.status);
        const isEnded = item.status === 2;
        return (
            <React.Fragment key={item.id || item._id || index}>
                <div key={item.id} className={classNames(styles.activityItem, isLeftSize ? styles.smallActivityItem : '' )} onClick={() => {
                    // this.props.history.push('/threadDetail/' + item.threadId);
                    window.open(`/threadDetail/${item.threadId}`);
                }}>
                    <img src={updateImageListSrc(item.coverUrl, 24)} alt={item.thread?.title} className={styles.activityCover} />
                    <div className={styles.activityTitleBox}>
                        <div className={classNames(styles.statusBox, inProgress ? styles.progressStatus : styles.endStatus)}>
                            <img src={inProgress ? `${BASE_IMG_URL}/common/activity-status1.png` : `${BASE_IMG_URL}/common/activity-status2.png`} alt="" className={styles.statusIcon} />
                            <div className={styles.statusText}>{statusText}</div>
                        </div>
                        <div 
                            className={styles.activityTitle}
                            dangerouslySetInnerHTML={{ 
                                __html: highlightname(item.thread?.title || item.thread?.summary, searchKeyword) || '活动标题'
                            }}
                            style={{ color: isEnded ? '#A7A9AC' : '' }}
                        />
                    </div>
                    <div className={styles.activityInfo}>
                        <div className={styles.activityTime}>{formatDateTime(item.endAt)}</div>
                        <div className={styles.postCount}>{formatNumberToWan(item.discussionCount)}讨论量</div>
                        {isEnded ? (
                            <div className={styles.statusBtn2}>{buttonText}</div>
                        ) : (
                            <div className={styles.statusBtn}>{buttonText}</div>
                        )}
                    </div>
                </div>
            </React.Fragment>
        );
    };


    render() {
        const { data, loading = false, hasMore = true, emptyText, emptyIcon, emptyBoxStyle, onLoadMore } = this.props;
        if (!Array.isArray(data)) return null;
        
        return <>
            <div className={styles.listBox}>
                <InfiniteScrollList
                    variant="pc"
                    data={data}
                    loading={loading}
                    hasMore={hasMore}
                    listClassName={styles.activityListBox}
                    onLoadMore={onLoadMore || (() => { })}
                    renderItem={this.renderActivityItem}
                    threshold={100}
                    emptyText={emptyText || '这里是空的'}
                    emptyIcon={emptyIcon}
                    emptyBoxStyle={emptyBoxStyle}
                    loadingText="加载中..."
                    noMoreText=""
                />
            </div>
            
        </>;
    }
}

export default withRouter(PCActivityList);